import Vue from 'vue';
import './plugins/vuetify';
import './plugins/cookies';
import './plugins/moment';
import App from './App.vue';
import router from './router';
import {store} from './_store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
